import React from 'react';
import { Box, Paper, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from 'recharts';

export default function AgentPerformanceChart({ data = {}, range = '7d', onRangeChange }) {
  const sample = data[range] || [];

  return (
    <Paper sx={{ p: 2, borderRadius: 2, boxShadow: '0 6px 18px rgba(15,23,42,0.06)' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="h6">Performance Overview</Typography>

        <ToggleButtonGroup
          size="small"
          value={range}
          exclusive
          onChange={(e, val) => val && onRangeChange(val)}
        >
          <ToggleButton value="today">Today</ToggleButton>
          <ToggleButton value="7d">7d</ToggleButton>
          <ToggleButton value="30d">30d</ToggleButton>
          <ToggleButton value="90d">90d</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Box sx={{ width: '100%', height: 300 }}>
        <ResponsiveContainer>
          <LineChart data={sample} margin={{ top: 8, right: 24, left: 0, bottom: 8 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="completed" stroke="#4caf50" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="earnings" stroke="#1976d2" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="acceptance" stroke="#0288d1" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
}
